import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["DropdownMenuPortal"], null, {
        default: _withCtx(() => [
            _createVNode($setup["DropdownMenuContent"], _mergeProps(_ctx.$attrs, {
                side: $props.side,
                "side-offset": $props.sideOffset,
                align: $props.align,
                class: $setup.cn('z-2500 min-w-32 rounded-md border border-border bg-popover p-2.5 text-popover-foreground shadow-md outline-none', 'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95', 'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95', $setup.props.class),
                onCloseAutoFocus: $setup.onCloseAutoFocus
            }), {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3 /* FORWARDED */
            }, 16 /* FULL_PROPS */, ["side", "side-offset", "align", "class"])
        ]),
        _: 3 /* FORWARDED */
    }));
}
